<style src="./InProgress.scss" lang="scss" scoped></style>
<template lang="html">
  <section class="in-progress">
    <ul class="inner-stages-container">
      <li
        class="inner-stage first-inner-stage">
        <div
          @click="changeInProgressStatus({ filterStatus: acceptanceProposal })"
          class="label-container">
          <span class="label">Proposta</span>
        </div>
        <div
          :class="{ 'active': filterStatus }"
          class="decorator">
          <div class="ghost-line"></div>
          <div class="indicator"></div>
          <div class="line"></div> 
        </div>

        <div
          v-if="filterStatus === acceptanceProposal && form.metaStatus"
          class="stage-moment">
          <span class="state">{{ form.metaStatus }}</span>
          <span class="statedate">{{ form.metaStatus === returnWhen ? form.returnDate : ''}}</span>
        </div>
      </li>
      <li
        class="inner-stage middle-inner-stage">
        <div
          @click="changeInProgressStatus({ filterStatus: inBid })"
          class="label-container">
          <span class="label">Em lances</span>
        </div>
        <div
          :class="{ 'active': filterStatus === inBid || filterStatus === enablingAcceptance }"
          class="decorator">
          <div class="line"></div>
          <div class="indicator"></div>
          <div class="line"></div>
        </div>

        <div
          v-if="filterStatus === inBid && form.metaStatus"
          class="stage-moment">
          <span class="state">{{ form.metaStatus }}</span>
          <span class="statedate">{{ form.metaStatus === returnWhen ? form.returnDate : ''}}</span>
        </div>
      </li>
      <li
        class="inner-stage last-inner-stage">
        <div
          @click="changeInProgressStatus({ filterStatus: enablingAcceptance })"
          class="label-container">
          <span class="label">Habilitação</span>
        </div>
        <div
          :class="{ 'active': filterStatus === enablingAcceptance }"
          class="decorator">
          <div class="line"></div>
          <div class="indicator"></div>
          <div class="ghost-line"></div>
        </div>

        <div
          v-if="filterStatus === enablingAcceptance && form.metaStatus"
          class="stage-moment">
          <span class="state">{{ form.metaStatus }}</span>
          <span class="statedate">{{ form.metaStatus === returnWhen ? form.returnDate : ''}}</span>
        </div>
      </li>
    </ul>

    <div class="status-definition">
      <div
        v-show="!statusCommand && filterStatus"
        @click="setStatusCommand(true)"
        class="status-action">
        <span class="label">Definir momento da etapa?</span>
      </div>

      <div
        v-if="statusCommand"
        class="status-command">
        <label class="option">
          <input
            type="radio"
            :value="null"
            v-model="form.metaStatus">
          <span class="text">Evento está em andamento normal</span>
        </label>
        <label class="option">
          <input
            type="radio"
            :value="waitinInteraction"
            v-model="form.metaStatus">
          <span class="text">Aguardando a informação de retorno.</span>
        </label>
        <label class="option">
          <input
            type="radio"
            :value="returnWhen"
            v-model="form.metaStatus">
          <datebox
            v-model="form.returnDate"
            label="Data do retorno"
            class="textbox" />
          <timebox
            v-model="form.returnTime"
            label="Hora do retorno"
            class="textbox" />
        </label>

        <div class="commands">
          <button
            class="status-button btn-ghost"
            type="button"
            @click="setStatusCommand(false)">
            Cancelar mudança
          </button>

          <button
            class="status-button btn-primary"
            type="button"
            @click="changeMetaStatus">
            <span class="title">Salvar a mudança de estágio</span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { IconDanger, IconClock } from '@/components/primitives/icons'
import { Textbox, Datebox, Timebox } from '@/components/primitives'
import moment from 'moment'

const ACCEPTANCE_PROPOSAL = 'ACEITAÇÃO'
const IN_BID = 'EM-LANCE'
const ENABLING_ACCEPTANCE = 'HABILITAÇÃO'
const WAITING_INTERACTION = 'AGUARDANDO'
const RETURN_WHEN = 'RETORNA-EM'

export default {
  name: 'InProgress',
  components: {
    IconDanger,
    IconClock,
    Textbox,
    Datebox,
    Timebox
  },
  props: {
    stageId: null,
    eventId: null,
    waiting: false,
    willStart: false,
    status: null,
    meta: null
  },
  data () {
    return {
      filterStatus: null,
      acceptanceProposal: ACCEPTANCE_PROPOSAL,
      inBid: IN_BID,
      enablingAcceptance: ENABLING_ACCEPTANCE,
      waitinInteraction: WAITING_INTERACTION,
      returnWhen: RETURN_WHEN,
      statusCommand: false,
      form: {
        stageStatus: null,
        returnDate: '',
        returnTime: '',
        metaStatus: ''
      }
    }
  },
  mounted () {
    this.fillForm()
  },
  methods: {
    async changeInProgressStatus ({ filterStatus }) {
      this.filterStatus = filterStatus
      await this.$store.dispatch('Board/INPROGRESS_STATUS', {
        eventId: this.eventId,
        stageId: this.stageId,
        filterStatus
      })
      this.$toasted.success('Alteração slava com sucesso')
    },
    async changeInProgressMetaStatus ({ metaStatus }) {
      const meta = { metaStatus }
      if (metaStatus === this.returnWhen) {
        const returnDate = moment(`${this.form.returnDate} ${this.form.returnTime}`, 'DD/MM/YYYY HH:mm:ss').toDate()
        meta.returnDate = returnDate
      }
      const payload = {
        eventId: this.eventId,
        stageId: this.stageId,
        filterStatus: this.filterStatus,
        meta
      }
      await this.$store.dispatch('Board/INPROGRESS_STATUS', payload)
      this.$toasted.success('Alteração slava com sucesso')
    },
    async resetInProgressMetaStatus () {
      const meta = null
      await this.$store.dispatch('Board/INPROGRESS_STATUS', {
        eventId: this.eventId,
        stageId: this.stageId,
        filterStatus: this.filterStatus,
        meta
      })
      this.$toasted.success('Alteração slava com sucesso')
    },
    fillForm () {
      this.form.returnDate = this.meta && this.meta.returnDate && moment(this.meta.returnDate).format('DD/MM/YYYY')
      this.form.metaStatus = this.meta && this.meta.metaStatus
      this.filterStatus = this.status
    },
    setStatusCommand (status) {
      this.statusCommand = status
    },
    changeMetaStatus () {
      switch (this.form.metaStatus) {
        case this.waitinInteraction:
          this.changeInProgressMetaStatus({ metaStatus: this.waitinInteraction })
          break
        case this.returnWhen:
          this.changeInProgressMetaStatus({ metaStatus: this.returnWhen })
          break
        default:
          this.resetInProgressMetaStatus()
          break
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/event/in-progress/InProgress.vue